import { type Locale, translate } from "../../shared/i18n";

export interface CvLabels {
  present: string;
  summary: string;
  experience: string;
  education: string;
  projects: string;
  skills: string;
  languages: string;
  certifications: string;
  awards: string;
  links: string;
  contact: string;
  email: string;
  phone: string;
  location: string;
  madeWith: string;
}

export function getCvLabels(locale: Locale): CvLabels {
  return {
    present: translate(locale, "cv.present"),
    summary: translate(locale, "cv.summary"),
    experience: translate(locale, "cv.experience"),
    education: translate(locale, "cv.education"),
    projects: translate(locale, "cv.projects"),
    skills: translate(locale, "cv.skills"),
    languages: translate(locale, "cv.languages"),
    certifications: translate(locale, "cv.certifications"),
    awards: translate(locale, "cv.awards"),
    links: translate(locale, "cv.links"),
    contact: translate(locale, "cv.contact"),
    email: translate(locale, "cv.email"),
    phone: translate(locale, "cv.phone"),
    location: translate(locale, "cv.location"),
    madeWith: translate(locale, "public.madeWith"),
  };
}
